export default __webpack_public_path__ + "static/media/compiegne18.f681f3cb.jpg";